import React from "react";
import {Navigate, Outlet} from "react-router";
import {AppPath} from "./AppRouter.jsx";
import {useAuth} from "../context/AuthContext.jsx";

export const ProtectedRoutes = (props) => {
    const { authIsInitializing, userIsAuthenticated } = useAuth();

    if(authIsInitializing) {
        return null
    }

    return (
        userIsAuthenticated ? <Outlet /> : <Navigate to={AppPath.login}/>
    )
}